import React from 'react'
import Modal from '~src/components/global/Modal'
import { LoadingSuccess } from '~src/components/screen/status/LoadingSuccess'
import { _format } from '~src/util'

type TPropsModal = {
  visible: boolean
  onCancel: () => void
  content: React.ReactNode
}

export const ModalShowNotification: React.FC<TPropsModal> = ({ visible, onCancel, content }) => {
  return (
    <Modal visible={visible} onCancel={onCancel} width={400} classModal="!top-[30%]">
      <LoadingSuccess />
      <div className="text-center w-full text-green">{content}</div>
    </Modal>
  )
}

export const ModalCustom: React.FC<TPropsModal> = ({ visible, onCancel, content }) => {
  return (
    <Modal
      visible={visible}
      maskClosable={false}
      onCancel={onCancel}
      width={400}
      classModal="!top-[30%]"
    >
      {content}
    </Modal>
  )
}
